// Simulates network latency; replace service bodies with Firestore calls later.
export function respond<T>(data: T, ms = 150): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(structuredClone(data)), ms));
}
